import { render, staticRenderFns } from "./LessonResource.vue?vue&type=template&id=346e7fdc&scoped=true"
import script from "./LessonResource.vue?vue&type=script&lang=js"
export * from "./LessonResource.vue?vue&type=script&lang=js"
import style0 from "./LessonResource.vue?vue&type=style&index=0&id=346e7fdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346e7fdc",
  null
  
)

export default component.exports